import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-schedule",
  "use": "icon-schedule-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-schedule\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M21 10v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V10h18zm-5.637 2.558a1 1 0 0 0-1.327.078l-3.244 3.243-1.12-1.122-.088-.077a1 1 0 0 0-1.327 1.492L10.086 18l.087.078A1 1 0 0 0 11.5 18l3.95-3.95.077-.087a1 1 0 0 0-.077-1.327zM15 4a1 1 0 0 1 2 0v1h3a1 1 0 0 1 1 1v2H3V6a1 1 0 0 1 1-1h3V4a1 1 0 1 1 2 0v1h6V4z\" fill=\"#A4B4D0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol